module.exports = __webpack_public_path__ + "img/slide11-piece-24.74d0fe08.png";